import React from "react";
import { SDLCMetadataTypeGuards } from "@sscs/types";
import { Checkbox, IconButton, InputAdornment, List, Menu, Select, } from "@sscs/ui";
import { CloseIcon } from "@sscs/ui/icons";
import { TRANSFORM_EXPLOIT_FLAG } from "../../../../constants";
import styles from "./vulnerabilityTagsFilter.module.scss";
const VulnerabilityTagsFilter = ({ value, onChange, className, ...props }) => {
    var _a;
    const filterOrder = [
        "MANDATE",
        "FIXABLE",
        "MALWARE",
        "EXISTS",
        "UNPROVEN",
    ];
    return (React.createElement(Select, { multiple: true, displayEmpty: true, shrinkLabel: true, "data-filtered-by-link": (_a = props["data-filtered-by-link"]) !== null && _a !== void 0 ? _a : false, id: "filter-tags", labelId: "tags-filter-label", label: "Filter by tags", value: value, renderValue: (value) => {
            if (Array.isArray(value)) {
                if (value.length === 0) {
                    return "Show all tags";
                }
                return value
                    .map((item) => SDLCMetadataTypeGuards.stringIsExploitPresence(item)
                    ? TRANSFORM_EXPLOIT_FLAG[item]
                    : item)
                    .join(", ");
            }
            else {
                return undefined;
            }
        }, onChange: (value) => onChange(value), endAdornment: value.length > 0 ? (React.createElement(InputAdornment, { position: "end" },
            React.createElement(IconButton, { className: styles["close-icon"], size: "small", onClick: () => onChange([]) },
                React.createElement(CloseIcon, null)))) : undefined, className: className, classes: { select: styles.select } }, filterOrder.map((tag) => (React.createElement(Menu.Item, { key: tag, id: tag, value: tag },
        React.createElement(Checkbox, { checked: value.includes(tag) }),
        React.createElement(List.ItemText, { primary: TRANSFORM_EXPLOIT_FLAG[tag] }))))));
};
export default VulnerabilityTagsFilter;
//# sourceMappingURL=VulnerabilityTagsFilter.js.map